import pluralize from 'pluralize'

import { Typography } from '@/shared'

interface Props {
    count: number
}

export const InvoicesHeader = ({ count }: Props) => {
    return (
        <div className="space-y-1">
            <Typography variant="h3">Invoices</Typography>

            <Typography variant="subtitle">
                {count ? `${count} new ${pluralize('invoice', count)} in this year` : 'No new invoices in this year'}
            </Typography>
        </div>
    )
}
